import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function ComparisonSection() {
  const {
    t
  } = useTranslation();
  return <section className="py-24 bg-lavender-50 relative" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-129">
          <h2 className="font-serif text-4xl text-gray-900 mb-4" data-id="element-130">
            {t.comparison.heading}
          </h2>
          <p className="text-sm text-gray-500 md:hidden" data-id="element-131">
            {t.comparison.scrollHint}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-sm border border-lavender-100 overflow-hidden mb-16" data-id="element-132">
          <div className="overflow-x-auto" data-id="element-133">
            <table className="w-full text-left border-collapse" data-id="element-134">
              <thead data-id="element-135">
                <tr className="bg-cream-50 border-b border-lavender-100" data-id="element-136">
                  <th className="py-4 px-6 font-serif text-lg text-gray-900 w-1/3 min-w-[180px]" data-id="element-137">
                    {t.comparison.colTried}
                  </th>
                  <th className="py-4 px-6 font-serif text-lg text-gray-900 w-2/3 min-w-[300px]" data-id="element-138">
                    {t.comparison.colShortfall}
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-139">
                {t.comparison.rows.map((row, index) => <tr key={index} className="border-b border-lavender-50 last:border-0 hover:bg-lavender-50/30 transition-colors" data-id="element-140">
                    <td className="py-4 px-6 text-gray-700 font-medium flex items-center gap-3" data-id="element-141">
                      <XCircle className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-142" />
                      {row.tried}
                    </td>
                    <td className="py-4 px-6 text-gray-600" data-id="element-143">{row.shortfall}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center max-w-2xl mx-auto" data-id="element-144">
          <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-145">
            {t.comparison.conclusion1}
          </p>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-146">
            {t.comparison.conclusion2}
          </p>
          <div className="inline-flex items-center justify-center bg-lavender-100 px-8 py-3 rounded-full" data-id="element-147">
            <p className="font-serif text-2xl text-lavender-700 font-semibold flex items-center gap-3" data-id="element-148">
              <CheckCircle2 className="w-6 h-6" data-id="element-149" />
              {t.comparison.weDo}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}